import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';
import { DrawerLetterBody } from '../../drawer/DrawerLetterBody';
import { LetterFormData } from '../hooks/useLetterForm';
import { LetterTypes, Sources } from '../types';

export interface ReinstatementDeclineContentProps {
  source: Sources;
  formData: LetterFormData;
  carrier: Carriers;
}

const ReinstatementDeclineContent = ({
  source,
  formData,
  carrier,
}: ReinstatementDeclineContentProps) => (
  <DrawerLetterBody
    letterType={LetterTypes.reinstatementDecline}
    pricingMode="higher"
    isJuvenile={false}
    carrier={carrier}
    carrierDisplayName={
      CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName() ?? ''
    }
    riders={[]}
    selectedRiders={[]}
    selectedSources={[source]}
    fieldValues={formData as Record<string, string>}
    hasFcra={false}
  />
);

export default ReinstatementDeclineContent;
